export function Panel({ title, right, children, className = "", testid }) {
  return (
    <section data-testid={testid} className={`gold-hairline rounded-xl border border-border bg-card panel-sheen shadow-[0_1px_0_hsl(var(--foreground)/0.03)_inset,0_12px_32px_-24px_rgba(0,0,0,0.6)] ${className}`}>
      {(title || right) && (
        <div className="flex items-center justify-between gap-2 px-4 h-10 border-b border-border">
          <h3 className="eyebrow flex items-center gap-2">{title && <span className="h-2.5 w-[2px] rounded-full bg-primary/80" />}{title}</h3>
          {right}
        </div>
      )}
      {children}
    </section>
  );
}

export function Metric({ label, value, sub, className = "", testid }) {
  return (
    <div className={`px-4 py-3.5 ${className}`}>
      <div className="eyebrow">{label}</div>
      <div className="num text-[19px] font-semibold mt-1.5 tracking-tight" data-testid={testid}>{value}</div>
      {sub && <div className="text-[11px] text-muted-foreground mt-0.5 num">{sub}</div>}
    </div>
  );
}

export function PageHeader({ title, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
      <div>
        <div className="eyebrow mb-1 flex items-center gap-2"><span className="h-px w-5 bg-primary" />Account</div>
        <h1 className="font-display font-bold text-2xl tracking-tight">{title}</h1>
      </div>
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}

export const th = "px-3 h-9 text-left eyebrow font-semibold whitespace-nowrap bg-muted/40";
export const td = "px-3 h-10 whitespace-nowrap text-[12.5px]";
export const btnGhost = "h-7 px-2.5 rounded-md border border-border text-[11px] font-medium hover:bg-accent hover:border-primary/40 hover:text-accent-foreground transition-colors duration-150";

export function Empty({ children, testid }) {
  return <div data-testid={testid} className="py-14 text-center text-muted-foreground text-[12.5px]">{children}</div>;
}
